import { Button, ButtonProps } from 'antd';
import React from 'react';

interface HWButtonProps extends ButtonProps {
  link?: string; // URL or route to navigate to
  target?: string;
}

export const HWButton: React.FC<HWButtonProps> = ({
  children,
  link,
  onClick,
  ...props
}) => {
  const disabledStyle = props.disabled
    ? {
        backgroundColor: '#d3c2e8',
        color: '#a391c4',
        border: '1px solid #d3c2e8',
        cursor: 'not-allowed',
      }
    : {};

  return (
    <Button
      {...props}
      href={link}
      onClick={onClick}
      style={{
        height: '38px',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '4px',
        backgroundColor: props.type === 'primary' ? '#5b1eaf' : 'transparent',
        color: props.type === 'primary' ? '#fff' : '#5b1eaf',
        border: props.type === 'primary' ? 'none' : '1px solid #5b1eaf',
        textDecoration: 'none',
        transition: 'none',
        transform: 'none',
        ...disabledStyle,
        ...props.style,
      }}
    >
      {children}
    </Button>
  );
};
